import React, { useState } from 'react';
import {
    Dialog,
    Box,
    Typography,
    Button,
    Slide,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import { AlertCircle } from 'lucide-react';

const PermissionAlert = ({
    open,
    onClose,
    question,
    confirmFlag,
}) => {
    const theme = useTheme();


    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            width={"70%"}
            maxWidth="sm"
            TransitionComponent={Slide}
            transitionDuration={500}
            keepMounted
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 2,
                    boxShadow: 3,
                    overflow: 'hidden',
                },
            }}
        >
            <Box
                sx={{
                    p: 3,
                    backgroundColor: theme.palette.background.paper,
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        mb: 1,
                        justifyContent: 'center',
                    }}
                >
                    <AlertCircle
                        size={28}
                        color={theme.palette.primary.main}
                    />
                    <Typography
                        variant={'h5'}
                        component="h1"
                        align="center"
                    >
                        Confirmation Required
                    </Typography>
                </Box>

                {/* Content */}
                <Typography
                    variant="body1"
                    sx={{
                        mb: 2,
                        textAlign: 'center',
                        fontSize: '1.1rem',
                        color: theme.palette.text.secondary,
                    }}
                >
                    {question}
                </Typography>

                {/* Actions */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        columnGap: 2
                    }}
                >
                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => {
                            confirmFlag(true);
                            onClose(false);
                        }}
                        sx={{
                            width: '33%',
                            padding: 1,
                            textTransform: 'none',
                            borderRadius: 1,
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: 2,
                            },
                        }}
                    >
                        Yes
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            confirmFlag(false);
                            onClose(false);
                        }}
                        sx={{
                            width: '33%',
                            padding: 1,
                            textTransform: 'none',
                            borderRadius: 1,
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: 2,
                            },
                        }}
                    >
                        No
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default PermissionAlert;